import { render, staticRenderFns } from "./StatsSection.vue?vue&type=template&id=5482b2b6&scoped=true&"
import script from "./StatsSection.vue?vue&type=script&lang=js&"
export * from "./StatsSection.vue?vue&type=script&lang=js&"
import style0 from "./StatsSection.vue?vue&type=style&index=0&id=5482b2b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5482b2b6",
  null
  
)

export default component.exports